<template>
  <div class="main">
    <div class="header">
      <img
        class="header-logo"
        src="../assets/logo.png"
        alt=""
        @click="backHome"
      />
      <div class="back" @click="backHome">幼儿园综合活动课程方案</div>
      <div v-if="user.nick_name" class="login-info">
        <span class="login-name">Hi,{{ user.nick_name }}</span>
        <span class="logout" @click="logout">退出</span>
      </div>
    </div>
    <div class="body">
      <div class="container">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Main',
  data: () => {
    return {
      activeIndex: '0',
      user: { nick_name: '', role: 'none' },
    }
  },
  mounted() {
    document.title = '幼儿园综合活动课程方案'
    let path = this.$route.path
    let user = JSON.parse(localStorage.getItem('yey-user')) || {}
    if (!user.nick_name && path != '/register' && path != '/filePreview') {
      this.$router.push('/login')
      return
    }
    this.user = user

    this.$eventBus.$on('refreshUserName', () => {
      user = JSON.parse(localStorage.getItem('yey-user')) || {}
      this.user = user
    })
  },
  methods: {
    backHome() {
      let user = JSON.parse(localStorage.getItem('yey-user')) || {}
      if (user.id) {
        this.$router.push('/home')
      } else {
        this.$router.push('/login')
      }
    },
    logout() {
      this.$confirm('确认退出登录吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$message({
          type: 'success',
          message: '已退出登录!',
        })
        localStorage.removeItem('yey-user')
        localStorage.removeItem('yey-token')
        this.$router.push('/login')
      })
    },
  },
}
</script>

<style lang="less">
.main {
  width: 100vw;
  height: 100vh;
  .menu-text {
    font-weight: 600;
    font-size: 16px;
  }
  .header {
    display: flex;
    align-items: center;
    position: relative;
    height: 100px;
    padding-left: 40px;
    line-height: 100px;
    font-size: 24px;
    font-weight: bold;
    color: #fff;
    text-align: left;
    background-image: url('../assets/headerBg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .header-logo {
      width: 66px;
      height: 66px;
      margin-right: 18px;
      cursor: pointer;
    }
    .back {
      cursor: pointer;
    }
  }

  .login-info {
    position: absolute;
    right: 40px;
    top: 0;
    height: 100px;
    line-height: 100px;
    font-size: 16px;

    .login-name {
      margin-right: 10px;
    }

    .logout {
      box-sizing: border-box;
      display: inline-block;
      width: 60px;
      height: 30px;
      margin-top: 20px;
      text-align: center;
      line-height: 30px;
      border-radius: 15px;
      border: 1px solid #fff;
      cursor: pointer;
    }
  }

  .body {
    display: flex;
    font-weight: 400;
  }

  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: calc(100vh - 100px);
    background-color: #f2f5f8;
    overflow-y: auto;

    .container-box {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding: 10px;
      background-color: #fff;
      overflow-y: auto;
    }
  }

  // 搜索公共样式
  .line {
    display: flex;
    padding: 20px;
  }

  .search-input {
    width: 180px;
    margin-right: 10px;
  }

  .search-select {
    width: 120px;
    margin-right: 10px;
  }

  .data-table {
    box-sizing: border-box;
    width: 100%;
    // height: calc(100vh - 240px);
    padding: 0 20px;
    margin-bottom: 10px;
  }

  .search-button {
    margin-right: 10px;
  }

  .el-table__header thead {
    border: 1px solid #e8f1fa;
    th {
      background: #f1f8ff;
    }
  }
  .el-table__body {
    tr:hover {
      td {
        background: #f8f8f8;
      }
    }
  }
}
</style>
